import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Report/ReportTypeCode', method: 'GET', body: null, token: token })
}
